import { Box, Stack, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useDealContext } from "../../../deal/context";
import { ITouchpoint, ViewpointStatus, IViewpoint } from "../../../../types";
import ClientProvider from "../../../../modules/ClientProvider";
import { useAuth0 } from "@auth0/auth0-react";
import { InsightsItem } from "../insights/InsightsItem";
import { DisplayBoxBase } from "../../../../components/shared/StyledComponents";
import { Link } from "react-router-dom";
import { Repeat2 } from "lucide-react";

export const ActiveTouchpoints = () => {

    const { dealContext } = useDealContext();
    const project = dealContext?.project;
    const touchpointClient = ClientProvider.provideTouchpointClient();
    const [touchpoints, setTouchpoints] = useState<ITouchpoint[]>([]);
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        const fetchTouchpoints = async () => {
            const accessToken = await getAccessTokenSilently();
            const { data, error } = await touchpointClient.getTouchpoints(project?.tag, accessToken);
            if (data.touchpoints) {
                setTouchpoints(data.touchpoints.filter((touchpoint: ITouchpoint) => touchpoint.status === "active" && touchpoint.viewpoints?.some((viewpoint: IViewpoint) => viewpoint?.status && viewpoint.status === ViewpointStatus.APPROVED)));
            }
        }
        fetchTouchpoints();
    }, []);

    if (touchpoints.length === 0) {
        return null;
    }

    return (
        <Box>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "1rem", width: "100%", marginBottom: "1rem" }}>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}><Repeat2 size={16} style={{marginBottom: "2px"}}/> Latest Insights</Typography>
                <Typography variant="body2" sx={{ color: "#7b8a99", fontWeight: 600 }}>
                    <Link to="/c/insights">
                        See all
                    </Link>
                </Typography>
            </Box>
            <Stack direction="column" gap={2}>
            {touchpoints.map((touchpoint) => (
                    <InsightsItem key={touchpoint.id} touchpoint={touchpoint} />
                ))}
            </Stack>
        </Box>
    )
}